import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ReactDataTable } from '@metarouter-private/mr-mui';

import useFeatureEnabled from 'app/launch-darkly/use-feature-enabled';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';
import BulkPlaybookUpdateTableTitle from './BulkPlaybookUpdateTableTitle';
import buildBulkPlaybookUpdateTableColumns from './buildBulkPlaybookUpdateTableColumns';
import useBulkPlaybookUpdateTable from './useBulkPlaybookUpdateTable';

export default function BulkPlaybookUpdateTable({ onCancel }) {
  const tableProps = useBulkPlaybookUpdateTable();
  const { pipelineTagsMvpEnabled } = useFeatureEnabled(FEATURE_FLAGS.pipelineTagsMvp);

  const columns = useMemo(
    () => buildBulkPlaybookUpdateTableColumns({ showTags: pipelineTagsMvpEnabled }),
    [pipelineTagsMvpEnabled]
  );

  return (
    <ReactDataTable title={<BulkPlaybookUpdateTableTitle onCancel={onCancel} />} columns={columns} {...tableProps} />
  );
}

BulkPlaybookUpdateTable.propTypes = {
  onCancel: PropTypes.func.isRequired,
};
